import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/context/I18nContext";

export default function GallerySection({ images = [] }) {
    const { t, localized } = useI18n();
    // Bento layout - 6 slots (tetris)
    const positions = [
        "md:col-span-6 md:row-span-2",  // 0 large left
        "md:col-span-3",                 // 1
        "md:col-span-3",                 // 2
        "md:col-span-4",                 // 3
        "md:col-span-4",                 // 4
        "md:col-span-4",                 // 5
    ];

    const items = images.slice(0, 6);
    while (items.length < 6 && images.length > 0) items.push(images[items.length % images.length]);

    return (
        <section id="gallery" data-testid="gallery-section" className="py-24 md:py-32 bg-habana-ink">
            <div className="mx-auto max-w-7xl px-6 md:px-10">
                <div className="flex items-end justify-between mb-12 flex-wrap gap-4">
                    <div>
                        <div className="ornament">{t("gallery_ornament")}</div>
                        <h2 className="mt-4 font-serif text-4xl sm:text-5xl md:text-6xl text-habana-cream">
                            {t("gallery_title")}
                        </h2>
                    </div>
                    <p className="text-habana-cream/60 max-w-md text-right hidden md:block">
                        {t("gallery_sub")}
                    </p>
                </div>

                {items.length === 0 ? (
                    <div className="text-habana-cream/40 italic text-center py-16">
                        No hay imágenes aún
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-12 auto-rows-[220px] gap-4">
                        {items.map((img, i) => (
                            <motion.div
                                key={`${img.id || img.url}-${i}`}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 0.8, delay: 0.05 * i, ease: [0.22, 1, 0.36, 1] }}
                                className={`relative overflow-hidden rounded-xl group border border-gold/10 col-span-1 ${positions[i] || "md:col-span-4"}`}
                                data-testid={`gallery-item-${i}`}
                            >
                                <img
                                    src={img.url}
                                    alt={localized(img, "caption") || "Cuban ambiance"}
                                    className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105"
                                    loading="lazy"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-90" />
                                <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between">
                                    <div className="font-serif italic text-habana-cream/90 text-sm md:text-base">
                                        {localized(img, "caption")}
                                    </div>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
}
